import { render, staticRenderFns } from "./DevImageBtn.vue?vue&type=template&id=3b1b7a52&scoped=true&"
import script from "./DevImageBtn.vue?vue&type=script&lang=js&"
export * from "./DevImageBtn.vue?vue&type=script&lang=js&"
import style0 from "./DevImageBtn.vue?vue&type=style&index=0&id=3b1b7a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b7a52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VFadeTransition,VHover,VIcon,VImg,VSheet})
